import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const SettingsIconTwo: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg
      fill="none"
      height="20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="1.5"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.834 18.334V9.167m0-3.333V1.667M10 18.334v-4.167m0-3.333V1.667M4.167 18.334V9.167m0-3.333V1.667" />
      <path d="M2.5 9.167h3.333m8.334 0H17.5m-9.166 1.666h3.333" />
    </svg>
  </SVGIcon>
);

export default SettingsIconTwo;
